import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from 'grommet';
import { useAppTheme } from '@Components/Context';
import {
  Seo, InfoNotice,
} from '@Components/Control';
import { withProductAuth } from '@Components/Layout';
import { AuthNavWrapper } from '@Components/Navigation';
import { DomainListTablePartial } from '@Components/Partial/Product/CompanySettings';
import {
  initiateNewSearchesTeamsRequest,
  clearNewSearchesTeamsRequest,
  updateNewSearchesTeamsRequest,
} from '@Actions';


const TeamsSettingsPage = ({
  small,
  location,
  loading,
  submitLoading,
  fetchCompanyTeams,
  updateCompanyTeams,
  clearCompanyTeams,
  paymentPending,
  companyTeams = null,
}) => {
  const { theme: { page }, isDarkMode } = useAppTheme();

  React.useEffect(() => {
    fetchCompanyTeams();

    return () => {
      clearCompanyTeams();
    };
  }, []);

  const usePageBg = isDarkMode ? page.background : page.altBg;

  return (
    <AuthNavWrapper
      small={small}
      location={location}
      bannerProps={{
        title: 'Manage teams',
        subTitle: 'Settings',
      }}
    >
      <Seo />
      <Box
        flex
        direction="column"
        background={usePageBg}
        pad={{ vertical: '1.5rem' }}
        height="100%"
        gap="1rem"
      >
        <InfoNotice
          header="Manage your teams"
          text="Teams added here will appear as selectable options when creating new searches from the New Search page"
        />
        <DomainListTablePartial
          unitsApiMode
          key="team-management-table"
          pageTitle="Teams"
          small={small}
          loading={Boolean(loading || submitLoading)}
          domainData={companyTeams?.teams}
          updateUnitsRequest={(values, actionType) => (
            updateCompanyTeams({ teams: values }, actionType)
          )}
          actionTerm="team"
          headerMap={[
            { uid: 'team', display: 'Team', size: small ? '75%' : '85%' },
            { uid: 'actions', display: 'Actions', size: small ? '25%' : '15%' },
          ]}
          paymentPending={paymentPending}
        />
      </Box>
    </AuthNavWrapper>
  );
};

function mapStateToProps(state) {
  return {
    loading: state.fetchLoader.dataLoading,
    submitLoading: state.fetchLoader.submissionLoading,
    companyTeams: state.productNewForm.companyTeams,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCompanyTeams: initiateNewSearchesTeamsRequest,
    updateCompanyTeams: updateNewSearchesTeamsRequest,
    clearCompanyTeams: clearNewSearchesTeamsRequest,
  }, dispatch);
}

TeamsSettingsPage.propTypes = {
  small: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  fetchCompanyTeams: PropTypes.func.isRequired,
  updateCompanyTeams: PropTypes.func.isRequired,
  clearCompanyTeams: PropTypes.func.isRequired,
  companyTeams: PropTypes.shape({
    teams: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  }),
  paymentPending: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductAuth(TeamsSettingsPage));
